import { render, staticRenderFns } from "./GoalCardItem.vue?vue&type=template&id=5cc57265&"
import script from "./GoalCardItem.vue?vue&type=script&lang=ts&"
export * from "./GoalCardItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports